var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content main-crm-content" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "container new-list" },
      _vm._l(_vm.newList, function(item, key) {
        return _c("div", { key: key, staticClass: "item" }, [
          _c("p", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
          _c("img", { attrs: { src: item.icon, alt: "" } }),
          _c("p", { staticClass: "con" }, [_vm._v(_vm._s(item.value))])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content-title" }, [
      _c("img", {
        staticClass: "img-box",
        attrs: { src: require("static/images/trait/FMS.png"), alt: "oa" }
      }),
      _c("h3", { staticClass: "services-title1" }, [_vm._v("财务管理系统")]),
      _c("p", { staticClass: "container-sub-title sub-title" }, [
        _vm._v(
          "财务管理系统，基于自主研发的OMS订单管理系统、仓库采购系统，保证了数据的来源和规范，更加方便和快速查询和处理应收应付款、对账结算、发票管理等， 能让企业迅速的统计和分析出企业的经营状态和财务收支情况。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ed56e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ed56e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/fms/Content.vue
// module id = 3iCa
// module chunks = 15